export default "__VITE_ASSET__CVX8RdRL__"